import React from "react";
import { Link } from "react-router-dom";
import StoryCard from "./StoryCard";

interface LocalStories {
  id: number;
  title: string;
  subtitle: string;
  websitee: string | null;
  phone: string | null;
  foldername: string;
  isactive: boolean;
  created_at: string;
}

interface Photo {
  id: number;
  localstoriesid: number;
  photo: string;
  isactive: boolean;
  created_at: string;
}

interface Section {
  id: number;
  localstoriesid: number;
  title: string | null;
  paragraph: string;
  isactive: boolean;
  created_at: string;
}

interface Story {
  localstories: LocalStories;
  photo: Photo[];
  section: Section[];
  location: any;
}

interface FilterStoryProps {
  filterStory: Story[];
}

export default function FilterStory({ filterStory }: FilterStoryProps) {
  //   const folderName = filterStory.foldername;
  //   const photos = filterStory.photo.map((item) => `${folderName}/${item.photo}`);
  //   console.log("folderName", folderName);


  return (
    <>
      <div className="slider-container explore-slider container p-0">
        <div className="sub-heading-white">Explore the Very Best of Dundee</div>
        <div className="row">
          {filterStory &&
            filterStory.map((item) => (
              <div className="col-12 col-md-6 col-lg-6 col-xl-3 p-1">
                <StoryCard item={item} />{" "}
              </div>
            ))}
        </div>
      </div>
    </>
  );
}
